export default __webpack_public_path__ + "static/media/Ficho-azul.7ee2d957.png";